import {
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibStackOverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay, 
  cibCcAmex
} from '@coreui/icons'
import {
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl
} from '@coreui/icons'
import {
  cilBan,
  cilBell,
  cilCheck,
  cilChevronBottom,
  cilChevronTop,
  cilCursor,
  cilDrop,
  cilEnvelopeOpen,
  cilEuro,
  cilGlobeAlt,
  cilJustifyCenter,
  cilLaptop,
  cilLightbulb,
  cilMagnifyingGlass,
  cilMoon,
  cilOptions,
  cilPuzzle,
  cilShieldAlt,
  cilUserFemale,
  cilXCircle

} from '@coreui/icons'

// Sidebar icons — replaced with Iconsax SVGs (cleaner outline style than CoreUI's pack).
// Re-exported under the same `cilXxx` names so `<CIcon name="cil-…"/>` keeps resolving.
import {
  cilArrowRight,
  cilBasket,
  cilBox,
  cilCalculator,
  cilCalendar,
  cilClock,
  cilFingerprint,
  cilCallIncoming,
  cilCallOutgoing,
  cilCash,
  cilChartBar,
  cilChartPie,
  cilChartUp,
  cilCheckCircle,
  cilCloudDownload,
  cilCloudUpload,
  cilCommentSquare,
  cilCup,
  cilDollar,
  cilEnvelopeClosed,
  cilFile,
  cilGrid,
  cilLayers,
  cilLibrary,
  cilList,
  cilLocationPin,
  cilLockLocked,
  cilNote,
  cilPencil,
  cilPeople,
  cilPhone,
  cilReceipt,
  cilRefund,
  cilBarcode,
  cilScan,
  cilSettings,
  cilSpeech,
  cilSpeedometer,
  cilStar,
  cilTask,
  cilTicket,
  cilTruck,
  cilUser,
  cilUserFollow,
  cilWallet,
  // De-duplication pass: unique, label-relevant sidebar glyphs.
  cilRoute,
  cilCart,
  cilBuilding,
  cilDevices,
  cilFlag,
  cilCreditCard,
  cilGift,
  cilHandCoin,
  cilShareArrow,
  cilSpreadsheet,
  cilReport,
  cilChartLine,
  cilUserChart,
  cilPhoneChart,
  cilMoneyBack,
  cilPackage,
  cilFunnel,
  cilInventory,
  cilCopy,
  cilAmazon,
  cilFlipkart,
  // Dashboard tile product glyphs (bottle / farm leaf / kgs weight), with
  // return-arrow + doubled "bulk" variants, plus rupee + refund-with-rupee.
  cilBottle,
  cilBottles,
  cilBottleReturn,
  cilBottleLeaf,
  cilBottlesLeaf,
  cilBottleLeafReturn,
  cilWeight,
  cilWeights,
  cilWeightReturn,
  cilRupee,
  cilRupeeRefund,
  cilInfinity,
} from './iconsax'
import { logo } from './logo'

export const iconsSet = Object.assign(
  {},
  { logo },
  {
    cilArrowRight,
    cilBan,
    cilBasket,
    cilBell,
    cilBox,
    cilCalculator,
    cilCalendar,
    cilClock,
    cilFingerprint,
    cilCallIncoming,
    cilCallOutgoing,
    cilCash,
    cilCloudDownload,
    cilCloudUpload,
    cilChartBar,
    cilChartPie,
    cilChartUp,
    cilCheck,
    cilChevronBottom,
    cilChevronTop,
    cilCheckCircle,
    cilCommentSquare,
    cilCup,
    cilCursor,
    cilDrop,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEuro,
    cilGlobeAlt,
    cilGrid,
    cilFile,
    cilJustifyCenter,
    cilLaptop,
    cilLayers,
    cilLibrary,
    cilLightbulb,
    cilList,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMoon,
    cilNote,
    cilOptions,
    cilPencil,
    cilPeople,
    cilPhone,
    cilPuzzle,
    cilReceipt,
    cilRefund,
    cilBarcode,
    cilScan,
    cilSettings,
    cilShieldAlt,
    cilSpeech,
    cilSpeedometer,
    cilStar,
    cilTask,
    cilTicket,
    cilTruck,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilWallet,
    cilXCircle,
    // De-duplication pass: unique, label-relevant sidebar glyphs.
    cilRoute,
    cilCart,
    cilBuilding,
    cilDevices,
    cilFlag,
    cilCreditCard,
    cilGift,
    cilHandCoin,
    cilShareArrow,
    cilSpreadsheet,
    cilReport,
    cilChartLine,
    cilUserChart,
    cilPhoneChart,
    cilMoneyBack,
    cilPackage,
    cilFunnel,
    cilInventory,
    cilCopy,
    cilAmazon,
    cilFlipkart,
    // Dashboard tile product glyphs (bottle / farm leaf / kgs weight), with
    // return-arrow + doubled "bulk" variants, plus rupee + refund-with-rupee.
    cilBottle,
    cilBottles,
    cilBottleReturn,
    cilBottleLeaf,
    cilBottlesLeaf,
    cilBottleLeafReturn,
    cilWeight,
    cilWeights,
    cilWeightReturn,
    cilRupee,
    cilRupeeRefund,
    cilInfinity
  },
  {
    cifUs,
    cifBr,
    cifIn,
    cifFr,
    cifEs,
    cifPl
  },
  {
    cibFacebook,
    cibTwitter,
    cibLinkedin,
    cibFlickr,
    cibTumblr,
    cibXing,
    cibGithub,
    cibStackOverflow,
    cibYoutube,
    cibDribbble,
    cibInstagram,
    cibPinterest,
    cibVk,
    cibYahoo,
    cibBehance,
    cibReddit,
    cibVimeo,
    cibCcMastercard, 
    cibCcVisa, 
    cibStripe, 
    cibPaypal, 
    cibGooglePay,
    cibCcAmex
  }
)

